import { getGlobalThis } from "@crystal/core/utils";
import { isServer } from "./utils.js";
const _Queue = class _Queue2 {
  constructor(id, isReady, commit) {
    this.getQueue = () => {
      const win = getGlobalThis();
      const id2 = Symbol.for(`${_Queue2.ID}-${this.id}`);
      return win[id2] = win[id2] ?? [];
    };
    this.tryCommitQueue = () => {
      if (!this.isReady()) {
        this.timerId = setTimeout(this.tryCommitQueue, _Queue2.TRY_INTERVAL);
        return;
      }
      this.getQueue().forEach((item) => this.commit(item));
      this.clear();
    };
    this.id = id;
    this.isReady = isReady;
    this.commit = commit;
    this._isCommitWaiting = false;
  }
  add(item) {
    if (isServer())
      return;
    this.getQueue().push(item);
  }
  addToFirst(item) {
    if (isServer())
      return;
    this.getQueue().unshift(item);
  }
  isEmpty() {
    return this.getQueue().length === 0;
  }
  tryCommit() {
    if (isServer() || this._isCommitWaiting)
      return;
    this._isCommitWaiting = true;
    this.tryCommitQueue();
  }
  clear() {
    this.getQueue().length = 0;
    clearTimeout(this.timerId);
    delete this.timerId;
    this._isCommitWaiting = false;
  }
  get length() {
    return this.getQueue().length;
  }
  get isCommitWaiting() {
    return this._isCommitWaiting;
  }
};
_Queue.ID = "analytics-queue";
_Queue.TRY_INTERVAL = 2e3;
let Queue = _Queue;
export {
  Queue
};
//# sourceMappingURL=queue.js.map
